const baseURL = `${process.env.REACT_APP_BASE_URL}/api/`

const headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
}

const NewsCloseApi = async (
    token: string,
    news_id: number
): Promise<any> => {
    const url = `${baseURL}news-close-update`;
    const data = new FormData();
    data.append("news_id", news_id.toString());

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + token
            },
            body: data
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

export { NewsCloseApi }
